document.addEventListener("DOMContentLoaded", () => {

  document.querySelectorAll(".pis-slider").forEach((slider) => {

    const slides = slider.querySelectorAll(".pis-slide");
    const dots = slider.querySelectorAll(".pis-dot");
    

    if (!slides.length) return;

    let current = 0;
    let autoplay;

    function showSlide(index){

      if(index < 0){
        index = slides.length - 1;
      }

      if(index >= slides.length){
        index = 0;
      }

      slides.forEach((slide)=>{
        slide.classList.remove("active");
      });

      dots.forEach((dot)=>{
        dot.classList.remove("active");
      });

      slides[index].classList.add("active");
      dots[index].classList.add("active");

      current = index;

    }

    function nextSlide(){
      showSlide(current + 1);
    }

    function prevSlide(){
      showSlide(current - 1);
    }

    

    dots.forEach((dot, i)=>{
      dot.addEventListener("click", ()=>{
        showSlide(i);
      });
    });

    function startAuto(){
      autoplay = setInterval(()=>{
        nextSlide();
      },5000);
    }

    function stopAuto(){
      clearInterval(autoplay);
    }

    slider.addEventListener("mouseenter", stopAuto);
    slider.addEventListener("mouseleave", startAuto);

    startAuto();

    /* ---------------- Swipe ---------------- */

    let startX = 0;
    let endX = 0;

    slider.addEventListener("touchstart",(e)=>{
      startX = e.changedTouches[0].clientX;
    });

    slider.addEventListener("touchend",(e)=>{

      endX = e.changedTouches[0].clientX;

      if(startX - endX > 50){
        nextSlide();
      }

      if(endX - startX > 50){
        prevSlide();
      }

    });

  });

});